import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('overview', {
    path: '/'
  }, function () {});
  this.route('activate', function () {});
  this.route('apps', function () {
    this.route('app', {
      path: '/:app_name'
    }, function () {
      this.route('overview');
      this.route('add-ons', function () {
        this.route('installed', function () {
          this.route('add-on', {
            path: '/:add_on_name'
          });
        });
        this.route('available');
      });
      this.route('action-runs', function () {
        this.route('action-run', {
          path: '/:action_name_run_sequence'
        });
      });
      this.route('settings');
    });
    this.route('create');
  });
  this.route('application-templates', {
    path: 'templates'
  }, function () {
    this.route('create');
    this.route('application-template', {
      path: ':application_template_name'
    }, function () {
      this.route('overview', {
        path: ''
      });
      this.route('settings', function () {
        this.route('template-details');
        this.route('terraform-details');
        this.route('action-assignments');
      });
    });
  });
  this.route('runs');
  this.route('actions', function () {
    this.route('create');
    this.route('action', {
      path: '/:action_name'
    }, function () {
      this.route('overview', {
        path: ''
      });
      this.route('run', {
        path: ':run_id'
      });
      this.route('assignments');
      this.route('settings', function () {
        this.route('general');
        this.route('assignments');
      });
    });
  });
  this.route('agent-groups', {
    path: 'agents'
  }, function () {
    this.route('agent-group', {
      path: ':agent_group_name'
    }, function () {
      this.route('overview', {
        path: ''
      });
      this.route('settings');
    });
    this.route('create');
  });
  this.route('add-on-definitions', {
    path: '/add-ons'
  }, function () {
    this.route('create');
    this.route('add-on-definition', {
      path: ':add_on_definition_name'
    }, function () {
      this.route('settings', function () {
        this.route('add-on-details');
        this.route('terraform-details');
      });
    });
  });
  this.route('integrations', function () {
    this.route('create');
  });
  this.route('settings', function () {
    this.route('view', {
      path: '/'
    });
    this.route('edit');
  });
});